import { render, staticRenderFns } from "./AccountLayout.vue?vue&type=template&id=621214a1&scoped=true&"
import script from "./AccountLayout.vue?vue&type=script&lang=js&"
export * from "./AccountLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccountLayout.vue?vue&type=style&index=0&id=621214a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621214a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621214a1')) {
      api.createRecord('621214a1', component.options)
    } else {
      api.reload('621214a1', component.options)
    }
    module.hot.accept("./AccountLayout.vue?vue&type=template&id=621214a1&scoped=true&", function () {
      api.rerender('621214a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/layout/AccountLayout.vue"
export default component.exports